import _regeneratorKeys from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regeneratorKeys.js";
import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import { Message } from 'element-ui';
import MemberNiceNameEdit from '../edit/index';
import MemberAuditEdit from '../audit/index';
export default {
  components: {
    MemberNiceNameEdit: MemberNiceNameEdit,
    MemberAuditEdit: MemberAuditEdit
  },
  name: 'MemberAudit',
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('member_select'),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      activeName: 'default',
      selectForm: {
        registerTime: [],
        noOrPhone: null,
        membershipAuditSts: 0,
        authorizationType: null
      },
      auditEditDisabled: false,
      auditDialogVisible: false,
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      provinces: [],
      citys: [],
      sex: [],
      memberV: [],
      memberTypes: [],
      memberSources: [],
      minAges: [],
      maxAges: [],
      educations: [],
      carPurchases: [],
      buyHouses: [],
      marriages: [],
      memberSumCounts: {}
    };
  },
  methods: {
    checkAuthType: function checkAuthType(type) {
      if (type === 1) {
        return '注销授权';
      } else if (type === 2) {
        return '团队授权';
      } else if (type === 3) {
        return '下载授权';
      } else if (type === 4) {
        return '红娘授权(旧)';
      } else if (type === 5) {
        return '代理授权(旧)';
      } else if (type === 6) {
        return '红娘授权';
      } else if (type === -1) {
        return '暂不授权';
      } else {
        return '';
      }
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.registerTime = [];
      this.selectForm.noOrPhone = null;
      this.selectForm.membershipAuditSts = 0;
      this.selectForm.authorizationType = null;
      this.initTableData();
    },
    memberNiceEditOpen: function memberNiceEditOpen(data) {
      this.dialogVisible = true;
      this.$refs.memberNiceNameEdit.setData(data);
    },
    memberAuditEditOpen: function memberAuditEditOpen(data) {
      this.auditDialogVisible = true;
      this.$refs.memberAuditEdit.setData(data);
    },
    memberAuditEditClose: function memberAuditEditClose() {
      this.auditDialogVisible = false;
    },
    memberNiceEditClose: function memberNiceEditClose() {
      this.dialogVisible = false;
    },
    getImagesImage: function getImagesImage(row) {
      if (row.headUrl.indexOf('http') !== -1) {
        return row.headUrl;
      }
      return this.downloadUrl + row.headUrl;
    },
    updateHomeTopApi: function updateHomeTopApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = [];
              _this.tableSelects.forEach(function (element) {
                par.push(element.memberId);
              });
              if (par.length === 0) {
                Message.error('请选择会员');
              } else {
                _this.$confirm('确定要取消推荐吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                  var index, id, proItem, _t, _t2;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _t = _regeneratorKeys(par);
                      case 1:
                        if ((_t2 = _t()).done) {
                          _context.n = 3;
                          break;
                        }
                        index = _t2.value;
                        id = par[index];
                        proItem = {
                          memberId: id,
                          homeTop: 0
                        };
                        _context.n = 2;
                        return api.UPDATE_MEMBER(proItem);
                      case 2:
                        _context.n = 1;
                        break;
                      case 3:
                        _this.initTableData();
                        _this.$message.success('操作成功');
                      case 4:
                        return _context.a(2);
                    }
                  }, _callee);
                }))).catch(function () {
                  _this.$message({
                    type: 'info',
                    message: '已取消操作'
                  });
                });
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getCarPurchasesEnumList: function getCarPurchasesEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'member_car_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this2.carPurchases = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this3.marriages = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getBuyHousesEnumList: function getBuyHousesEnumList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: 'member_buyHouse_select'
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this4.buyHouses = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                pageNo: _this5.pageNo,
                pageSize: _this5.pageSize,
                noOrPhone: _this5.selectForm.noOrPhone,
                membershipAuditSts: _this5.selectForm.membershipAuditSts,
                authorizationType: _this5.selectForm.authorizationType,
                membership: 3,
                sortType: 1
              };
              if (_this5.selectForm.registerTime.length >= 2) {
                par.registerStartTime = _this5.selectForm.registerTime[0];
                par.registerEndTime = _this5.selectForm.registerTime[1];
              }
              _context6.n = 1;
              return api.getMatchmakerAuditPageList(par);
            case 1:
              res = _context6.v;
              _this5.tableData = res.body.datas;
              _this5.pageTotal = res.body.sumDataCount;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    initProvinces: function initProvinces() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.GET_PROVINCE_LIST();
            case 1:
              res = _context7.v;
              _this6.provinces = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    initCitys: function initCitys() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context8.v;
              _this7.citys = res.body;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    addWarningApi: function addWarningApi(data) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return api.ADD_MEMBER_WARNING(data);
            case 1:
              Message.success('操作成功');
              _this8.initTableData();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getMemberSumCounts: function getMemberSumCounts() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return api.GET_MEMBER_SUM_COUNT();
            case 1:
              res = _context0.v;
              _this9.memberSumCounts = res.body;
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    updateApi: function updateApi(data) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var pro;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              pro = {
                memberId: data.memberId,
                membershipAuditSts: data.membershipAuditSts === 0 ? 1 : 0,
                auditSts: true
              };
              _context1.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              Message.success('操作成功');
              _this0.initTableData();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    update: function update(data) {
      var _this1 = this;
      this.$confirm('确定开通红娘权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this1.updateApi(data);
      }).catch(function () {
        _this1.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};